<template>
  <router-view />
</template>
<script>
export default {
  name: 'Participants',
};
</script>
